import { render, staticRenderFns } from "./SidebarProgressbar.vue?vue&type=template&id=984039d2"
import script from "./SidebarProgressbar.vue?vue&type=script&lang=js"
export * from "./SidebarProgressbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports